import { cn } from '@qr-front/ui/utils'

import { CheckIcon } from './CheckIcon'
import { TStepProps } from './types'

export const Clone1Step = ({
	index,
	state,
	labelMobile,
	labelDesktop,
	hideLabel,
}: TStepProps) => {
	const label = (
		<p
			className={cn(
				labelMobile ? '' : 'hidden',
				labelDesktop ? 'tablet:inline' : 'tablet:hidden',
				'type-body-small',
				state === 'current' && 'text-black transition-colors',
			)}
		>
			<span className="tablet:hidden">{labelMobile}</span>
			<span className="hidden tablet:inline">{labelDesktop}</span>
		</p>
	)

	return (
		<div className="flex items-center gap-1 whitespace-nowrap desktop:gap-2">
			<div
				className={cn(
					'flex h-6 w-7 items-center justify-center rounded-full border border-border-grey transition-colors',
					state === 'current' && 'border-none bg-blue text-white',
				)}
			>
				{state === 'completed' ? (
					<CheckIcon className="size-3" />
				) : (
					<span className="type-body-caption">{index + 1}</span>
				)}
			</div>
			{!hideLabel ? label : null}
		</div>
	)
}
